import { render, staticRenderFns } from "./BlackGoldGamePreviewModal.vue?vue&type=template&id=305e23ac"
import script from "./BlackGoldGamePreviewModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldGamePreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports